(function () {
    'use strict';
    angular.module('app').controller('IssueCreditNoteModalController', IssueCreditNoteModalController);
    IssueCreditNoteModalController.$inject = [
        'shipments',
        'invoiceData',
        'CreditNoteAuditTrailTable',
        'LineItemsTable',
        '$uibModalInstance',
        '$timeout',
        'AccountingService',
        '$q',
        'toastr',
        '$filter'
    ];

    function IssueCreditNoteModalController(
        shipments,
        billingData,
        CreditNoteAuditTrailTable,
        LineItemsTable,
        $uibModalInstance,
        $timeout,
        AccountingService,
        $q,
        toastr,
        $filter
    ) {
        const vm = this;
        vm.shipments = shipments;
        vm.invoiceData = billingData;
        vm.creditNote = {};

        vm.issueCreditDebitNote = issueCreditDebitNote;
        vm.cancel = cancel;
        vm.updateCallback = updateCallback;

        init();

        function init() {
            vm.currency = shipments[0].currency;
            initializeTablesData();
        }

        function initializeTablesData() {
            vm.creditNoteAuditTrailTable = new CreditNoteAuditTrailTable({id: shipments[0].invoiceId}).tableData;
            getCreditNoteDetails().then(data => {
                const lineItems = [];
                shipments.forEach(item => {
                    const foundShipment = data.lineItems.find(shipmentWithCreditNote => shipmentWithCreditNote.consignmentId === item.consignmentId);
                    if (foundShipment) {
                        foundShipment.disabled = true;
                        foundShipment.typeEdit = foundShipment.amountEdit < 0 ? 'DEBIT NOTE' : 'CREDIT NOTE'
                        lineItems.push(foundShipment);
                    } else {
                        lineItems.push({
                            consignmentId: item.consignmentId,
                            amount: 0,
                            description: '',
                            quantity: 1,
                            unitAmount: 0,
                            currency: item.currency
                        });
                    }
                });
                data.lineItems = lineItems;

                $timeout(() => {
                    vm.creditNote = data;
                    vm.lineItemsTableData = new LineItemsTable({
                        data: data,
                        form: vm.lineItemsTableForm
                    }, updateCallback).tableData;
                });
            }, error => {
                const lineItems = [];
                shipments.forEach(item => {
                    lineItems.push({
                        consignmentId: item.consignmentId,
                        amount: 0,
                        description: '',
                        quantity: 1,
                        unitAmount: 0,
                        currency: item.currency
                    });
                });

                vm.lineItemsTableData = new LineItemsTable({
                    data: {
                        lineItems: lineItems
                    },
                    form: vm.lineItemsTableData
                }, updateCallback).tableData;
            });
        }

        function getCreditNoteDetails() {
            const defer = $q.defer();
            AccountingService.IssuedCreditNotes.creditNoteDetails(success => {
                defer.resolve(success);
            }, error => {
                defer.reject(error);
            }, billingData.id);
            return defer.promise;
        }

        function updateCallback() {
            let subTotalAmount = 0;
            vm.lineItemsTableData.data.forEach(data => {
                subTotalAmount += Number(data.amountEdit.value);
            });

            vm.creditNote.subTotalAmount = $filter('currency')(subTotalAmount, '');
            vm.creditNote.taxAmount = $filter('currency')(subTotalAmount * .10, '');
            vm.creditNote.totalAmount = $filter('currency')(Number(vm.creditNote.taxAmount) + Number(vm.creditNote.subTotalAmount), '');
        }

        function issueCreditDebitNote() {
            vm.issuingCreditNote = true;
            if (!vm.lineItemsTableForm.$valid || !vm.referenceForm.$valid) {
                vm.lineItemsTableForm.$setSubmitted();
                vm.referenceForm.$setSubmitted();
                vm.issuingCreditNote = true;
                return false;
            }

            // TEST CODE ONLY
            console.log(generateData());

            const notIssuedCreditNote = vm.lineItemsTableData.data.filter(item => !item.disabled);
            if (notIssuedCreditNote.length !== 0) {
                AccountingService.HistoricalBilling.issueCreditNote(success => {
                    vm.issuingCreditNote = false;
                    toastr.success("Credit Note Issued", "Success");
                }, error => {
                    toastr.error(error.message, "Error");
                    vm.issuingCreditNote = false;
                }, generateData(), billingData.id);
            } else {
                vm.issuingCreditNote = false;
                toastr.info('All credit/debit note has been issued.');
            }
        }

        function generateData() {
            return {
                customerId: billingData.customer.id,
                currency: shipments[0].currency,
                lineItems: vm.lineItemsTableData.data.map(item => {
                    return {
                        consignmentId: item.consignmentIdEdit.value,
                        description: item.descriptionEdit.model,
                        unitAmount:  item.typeEdit.model === 'CREDIT NOTE' ? Number(item.amountEdit.value) : Number(item.amountEdit.value) * -1,
                        quantity: 1,
                        amount: item.typeEdit.model === 'CREDIT NOTE' ? Number(item.amountEdit.value) : Number(item.amountEdit.value) * -1,
                    }
                }),
                reference: vm.creditNote.reference,
                subTotalAmount: Number(vm.creditNote.subTotalAmount),
                taxAmount: Number(vm.creditNote.taxAmount),
                totalAmount: Number(vm.creditNote.totalAmount)
            }
        }

        function cancel() {
            $uibModalInstance.dismiss();
        }
    }
})();



// WEBPACK FOOTER //
// ./js/controllers/accounting/modals/IssueCreditNoteModalController.js